import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store';
import UserService from '../services/user.service';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
	routes, // short for routes: routes
	linkActiveClass: 'active',
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return { selector: to.hash };
		}
		return { x: 0, y: 0 };
	},
});

router.beforeEach(async (to, from, next) => {
	if (['/signup', '/login', '/'].includes(to.path)) {
		if (process.env.VUE_APP_MODE === 'local') {
			next('/toppage');
			return;
		}
		next();
		try {
			await store.dispatch('global/auth/validateToken');
		} catch (error) {
			if (error.response.status === 401) {
				localStorage.removeItem('token');
				next('/login');
				return;
			}
		}
		return;
	}

	if (to.path !== '/profile' && process.env.VUE_APP_MODE !== 'local') {
		try {
			await UserService.validateUserStatus();
		} catch (error) {
			next('/profile');
			return;
		}
	}

	if (from.path === '/toppage' && to.path === '/trainer') {
		store.dispatch('trainer/showFormModal');
	}

	next();
});

export default router;
